function initGlytoneCheckoutForm(form) {
  if (!form || form.dataset.checkoutInitialized === 'true') return;

  form.dataset.checkoutInitialized = 'true';

  const button = form.querySelector('[data-glytone-checkout-button]');
  const message = form.querySelector('[data-glytone-checkout-message]');

  if (!button) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (button.disabled) return;

    button.disabled = true;
    button.classList.add('is-loading');

    if (message) {
      message.textContent = '';
    }

    try {
      const formData = new FormData(form);

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || 'Unable to add item to cart.');
      }

      window.location.href = '/checkout';
    } catch (error) {
      console.error(error);

      button.disabled = false;
      button.classList.remove('is-loading');

      if (message) {
        message.textContent = error.message;
      }
    }
  });
}

function initAllGlytoneCheckoutForms(scope = document) {
  scope
    .querySelectorAll('[data-glytone-checkout-form]')
    .forEach(initGlytoneCheckoutForm);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAllGlytoneCheckoutForms();
  });
} else {
  initAllGlytoneCheckoutForms();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllGlytoneCheckoutForms(event.target);
});